/**
 * React Query QueryClient 설정
 * 전역 기본값 및 retry 전략 포함
 */

import { QueryClient } from "@tanstack/react-query";

import { HTTP_ERROR_VALUE } from "@/shared/constants";

import { ApiError } from "./config";

const NON_RETRYABLE_STATUSES = [
  HTTP_ERROR_VALUE.UNAUTHORIZED,
  HTTP_ERROR_VALUE.FORBIDDEN,
  HTTP_ERROR_VALUE.NOT_FOUND,
] as const;

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError) {
    // 인증/권한/404 에러는 재시도하지 않음
    if (NON_RETRYABLE_STATUSES.includes(error.status as (typeof NON_RETRYABLE_STATUSES)[number])) {
      return false;
    }
  }
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1분
        refetchOnWindowFocus: false,
        retry: shouldRetry,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
